/* eslint-disable @typescript-eslint/no-unused-vars */
import { Environment } from '../../../../environment';
import { v4 as uuidv4 } from 'uuid';
import { Apiestoque } from '../../axiosestoque';
import axios, { AxiosError } from 'axios';

type NullableDate = Date | null | undefined;

interface IImage {
  imgPath: string;
}

export interface IListagemOS {
  idos: string;
  numero: number;
  dataabertura: Date;
  patrimonio: string;
  nomepatrimonio: string;
  modelo: string;
  situacao: string;
}

export interface IGetAbas {
  idabastecimento: string,
  idpatrimonio: string,
  numero: string,
  idfazenda: string,
  preco: number,
  descricao: string,
  marca: string,
  modelo: string,
  dataoperacao: Date,
  operador: string,
  idprod: string,
  horimetronicial: number,
  horimetro: number,
  horastrabalhadas: number,
  quantidade: number,
  idpivot: string,
  idcultivo: string,
  idatividade: string,
  fotos: IImage[],
}

interface IItensids{
  iditens: string;
}

export interface IitensSaidaDialog{
  iditens: string;
  idprod: string;
  idlocalizacao: string; 
  qtdsaida: number; 
  validade?: string | null;
  un: string;
  qtdentrada: number;
  conversor: number;
  preco: number;
  total: number;
  referencia: string;
  qtdestoque: number;
  filtro: string;
  descricao: string;
  localizacao: string;
  reqvencimento: boolean;
}

export interface IAbasList {
  idabastecimento: string;
  dataoperacao: Date;
  numero: number
  fazenda: string,
  horimetro: number
  patrimonio: string;
  quantidade: number
  litros: number
  cultivo: string;
  pivot: string;
  atividade: string;
}

type TotalCount = {
  data: IAbasList[];
  totalCount: number; 
}

export interface IDetalheAbastecimento  {
  idpatrimonio:string,
  idprod:string,
  dataoperacao: Date,
  idcultivo?: string | null;
  idpivot?: string | null;
  idatividade: string,
  horimetro: number,
  horimetronicial: number,
  quantidade: number,
  preco:number,
  total:number,
  operador: string,
  horastrabalhadas: number,
  litros: number,
  kmhr: string,
  quantidadeestoque: number,
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, dataInicial= '', dataFinal='', filter = '', tipo=''): Promise<TotalCount | Error> => {
  try {
 
    const urlRelativa = `/abastecimento?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&tipo=${tipo}&datai=${dataInicial}&dataf=${dataFinal}&filter=${filter}`;
    const { data, headers } = await Apiestoque.get(urlRelativa);
    if (data) { 
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }  
};

const getById = async (id: string): Promise<IGetAbas | Error> => {
  try {
    const { data } = await Apiestoque.get(`/abastecimento/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateById = async (id: string, dados: IDetalheAbastecimento): Promise<void | Error> => {
  try {
    const guuid = uuidv4();
    const { quantidadeestoque, kmhr, litros, ...dadosIDetalheAbastecimento } = dados;
    await Apiestoque.put(`/abastecimento/${id}`, {idabastecimento: guuid, ...dadosIDetalheAbastecimento});
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Apiestoque.delete(`/abastecimento/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const AbastecimentoService = {
  getAll,
  getById,
  updateById,
  deleteById,
};